import Network from "./Network";

const GetSectionItemsQuery = async (section) => {
    console.log("get section items")
    const response = await Network().get(`/public?type=${section}`)
    return response.data
}
export default GetSectionItemsQuery
